var $menu,
    $header,
    $menuClose,
    $menuOpen,
    $searchOpen,
    $menuToggle;

var $menuTab,
    $searchTab,
    $filterTab,
    $headerSearch,
    $searchForm,
    $searchInput,
    $program,
    $filterForm,
    $filterInput,
    $filterInputInLayer,
    $filterSubmit,
    $filterSubmenuOpen,
    $filterSubmenuClose,
    $submenuTitle,
    $programLayer;

var $searchSpinner;
var $resetSearchFilter;

$(document).ready(function ($) {

    $menu = $('.js-menu');
    $header = $('.js-header');
    $menuClose = $('.js-menu-close');
    $menuOpen = $('.js-menu-open');
    $searchOpen = $('.js-search-open');
    $menuToggle = $('.js-menu-toggle');

    $menuTab = $('.js-tab-menu');
    $searchTab = $('.js-tab-search');
    $filterTab = $('.js-tab-filter');
    $headerSearch = $('.js-header-search');
    $searchInput = $('.js-search input');
    $searchForm = $('.js-search');
    $program = $('.js-program');
    $filterForm = $('.js-search-program');
    $filterInput = $('.js-filter-search-input');
    $filterInputInLayer = $('.js-layer-program-filter input');
    $filterSubmit = $('.js-filter-open');
    $filterSubmenuOpen = $('.js-subfilter-open');
    $filterSubmenuClose = $('.js-subfilter-close');
    $submenuTitle = $('.js-submenu-title')
    $programLayer = $('.js-program-search-layer');

    $searchSpinner = $('.js-loading-search');
    $resetSearchFilter = $('.js-reset-program-search');

    const disabledKeys = [
      13, 16, 224, 32, 37, 38, 39, 40
    ];

    $menuClose.on('click', function () {
        closeMenu();
    });

    $menuOpen.on('click', function () {
        openMenu();
    });

    $menuToggle.on('click', function () {
        if ($menu.hasClass('is-open')) {
            closeMenu();
        } else {
            openMenu();
        }
    });

    $searchOpen.on('click', function () {
        focusInput();
    });

    $resetSearchFilter.on('click', function () {
        $filterInput.val('');
        showFilterTaxonomyResults({});
    });

    $filterSubmenuOpen.on('click', function (e) {
        e.preventDefault();
        let $thisRef = $(this);
        $thisRef.parent().parent().addClass('has-open-submenu');
        $thisRef.parent().addClass('is-open');

        let tabTitle = $thisRef.attr('data-title');
        $submenuTitle.html(tabTitle);
        $submenuTitle.parent().addClass('show-next');
    });


    $filterSubmenuClose.on('click', function (e) {
        e.preventDefault();
        $('.js-filter').removeClass('has-open-submenu');
        $('.js-filter-group').removeClass('is-open');

        $submenuTitle.parent().removeClass('show-next');
    });


    var time = 0;
    $searchInput.on('keyup', function (e) {

      if ( $.inArray(e.keyCode, disabledKeys) !== -1 ) {
        return;
      } 

        var delay = 500;
        // Reset the timer
        clearTimeout(time);

        time = setTimeout(function () {
            if ($searchInput.val().length > 1) {
                showTab($searchTab);
                showSearchResults();
            } else {
                showTab($menuTab);
            }
        }, delay);
    });

    $searchForm.on('submit', function (e) {
        e.preventDefault();
    });

    $filterForm.on('submit', function (e) {
        e.preventDefault();
    });

    $filterSubmit.on('click', function (e) {
        e.preventDefault();
        openMenu();
        showTab($filterTab);
    });

    $filterInputInLayer.on('focusin', function () {
        var offset = $programLayer.offset().top;
        offset = parseInt(offset, 10) - 50;

        if (parseInt($(window).width()) > 992) {
            window.scrollTo({top: offset, behavior: 'smooth'});
        }
    });

    var filterTime = 0;
    $filterInput.on('keyup', function (e) {

        if ( $.inArray(e.keyCode, disabledKeys) !== -1 ) {
          return;
        } 

        var delay = 500;
        // Reset the timer
        clearTimeout(filterTime);
        $filterInput.val($(this).val());

        filterTime = setTimeout(function () {
            if ($filterInput.val().length > 1 || $filterInput.val().length === 0) {
                showFilterTaxonomyResults({});
            }
        }, delay);

        if ($(this).val().length > 0) {
            $('.js-filter-tags').addClass('is-searching');
        }
    });

    $filterInput.keypress(function (e) {
        if (e.which == 13) e.preventDefault();
    });
});


// Open main menu
function closeMenu() {
    $menu.removeClass('is-open');
    $header.removeClass('is-open');
    $searchInput.val('');
    closeFilter();
    $submenuTitle.parent().removeClass('show-next');
}


// Open main menu
function openMenu() {
    $menu.addClass('is-open');
    $header.addClass('is-open');

    showTab($menuTab);
}


function closeFilter() {
    $('.js-filter').removeClass('has-open-submenu');
    $('.js-filter-group').removeClass('is-open');
}

// Show search or menu tab
function showTab($tabToShow) {
    $menuTab.removeClass('is-open');
    $searchTab.removeClass('is-open');
    $filterTab.removeClass('is-open');
    $headerSearch.show();

    if ($tabToShow === $menuTab) {
        $menuTab.addClass('is-open');
    }

    if ($tabToShow === $searchTab) {
        $searchTab.addClass('is-open');
    }

    if ($tabToShow === $filterTab) {
        $filterTab.addClass('is-open');
        $headerSearch.hide();
    }
}

// Autofocus Input
function focusInput() {
    $searchInput.focus();
}


function showSearchResults() {
    $searchSpinner.addClass('is-loading');

    jQuery.ajax({
        url: linku_ajax_url,
        type: 'post',
        data: {
            action: 'search',
            search: $searchInput.val(),
        },
        dataType: 'json',
        success: function (response) {
            $searchTab.empty();

            if (response.event_html && response.event_items > 0) {
                $searchTab.append(response.event_html);
            }

            if (response.archive_html && response.archive_items > 0) {
                $searchTab.append(response.archive_html);
            }

            if (response.page_html) {
                $searchTab.append(response.page_html);
            }


            if (response.blog_html) {
                $searchTab.append(response.blog_html);
            }


            if (response.event_html && response.event_items < 1) {
                $searchTab.append(response.event_html);
            }

            $searchSpinner.removeClass('is-loading');
        },
        error: function () {
            $searchSpinner.removeClass('is-loading');
        }
    });
}

function updateFilterUrl() {
    $allFilters = $('.js-add-filter');
}


function showFilterTaxonomyResults(data) {

    jQuery.ajax({
        url: linku_ajax_url,
        type: 'post',
        data: {
            action: 'filter_taxonomy',
            data: data,
            search: $filterInput.val(),
        },
        dataType: 'json',
        success: function (response) {
            $program.empty();
            $program.append(response.program_html);
            LayerSystem.reset();
        }
    });
}
